import { render, staticRenderFns } from "./NoticePanel.vue?vue&type=template&id=347c2238&scoped=true&lang=pug&"
import script from "./NoticePanel.vue?vue&type=script&lang=ts&"
export * from "./NoticePanel.vue?vue&type=script&lang=ts&"
import style0 from "./NoticePanel.vue?vue&type=style&index=0&id=347c2238&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347c2238",
  null
  
)

export default component.exports